import { IApplicationState } from '../../types/redux';

export function getNewbuldingFromTheBuilderLink(state: IApplicationState) {
  const {
    newbuilding: { newbuildingsFromTheBuilderLink },
  } = state;

  return newbuildingsFromTheBuilderLink;
}
